import { Readable, Convertable, Value, Compareable } from './ModelUtil'
import moment from 'moment'

export default class CaregiverModel {
  constructor () {
    this.id = null
    this.nickName = ''
    this.name = ''
    this.gender = ''
    this.weight = null
    this.height = null
    this.nationality = 0
    this.birthDate = ''
    this.maritalStatus = ''
    this.hasChildren = null
    this.children = null
    this.religion = ''
    this.citizenId = null
    this.citizenIdPhoto = ''
    this.shirtSize = ''
    this.photo = ''
    this.phone = ''
    this.line = ''
    this.emergencyContact = {
      name: '',
      relation: '',
      phone: '',
    }
    this.address = {
      address: '',
      province: '',
      subdistrict: '',
      district: '',
    }
    this.hometown = ''
    this.bankAccount = {
      number: '',
      name: '',
      bank: '',
    }
    this.education = ''
    this.educationPlace = ''
    this.careCertification = ''
    this.careCertificationPlace = ''
    this.type = ''
    this.class = 0
    this.classYear = 0
    this.publicType = ''
    this.skills = Value.skill.all().map(s => ({
      name: s,
      score: null,
      improvable: false
    }))
    this.yearOfExp = null
    this.category = ''
    this.rating = 5
    this.note = ''
    this.level = 0
    this.levelUpdatedAt = ''
    this.overviewNote = ''
    this.personalityNote = ''
    this.skillNote = ''
    this.notSuitableNote = ''
  }

  static fromJSON (json) {
    let caregiver = new CaregiverModel()
    caregiver.id = json.id
    caregiver.name = json.name
    caregiver.nickName = json.nickName
    caregiver.gender = json.gender
    caregiver.weight = Value.notZeroOrNull(json.weight)
    caregiver.height = Value.notZeroOrNull(json.height)
    caregiver.birthDate = json.birthDate
    caregiver.nationality = json.nationality
    caregiver.maritalStatus = json.maritalStatus
    caregiver.hasChildren = json.hasChildren
    caregiver.children = Value.notZeroOrNull(json.children)
    caregiver.religion = json.religion
    caregiver.citizenId = json.citizenId
    caregiver.citizenIdPhoto = json.citizenIdPhoto
    caregiver.shirtSize = json.shirtSize
    caregiver.photo = json.photo
    caregiver.phone = json.phone
    caregiver.line = json.line
    caregiver.emergencyContact = json.emergencyContact
    caregiver.address = json.address
    caregiver.hometown = json.hometown
    caregiver.bankAccount = json.bankAccount
    caregiver.education = json.education
    caregiver.educationPlace = json.educationPlace
    caregiver.careCertification = json.careCertification
    caregiver.careCertificationPlace = json.careCertificationPlace
    caregiver.type = json.type
    caregiver.class = json.class
    caregiver.classYear = json.classYear
    caregiver.publicType = json.type
    caregiver.skills = json.skills.sort(Compareable.skillName)
    caregiver.yearOfExp = Value.notZeroOrNull(json.yearOfExp)
    caregiver.category = json.category
    caregiver.rating = Value.notZeroOrNull(json.rating)
    caregiver.note = json.note
    caregiver.createdAt = json.createdAt
    caregiver.updatedAt = json.updatedAt
    caregiver.lastActive = json.lastActive
    caregiver.level = json.level
    caregiver.levelUpdatedAt = json.levelUpdatedAt
    caregiver.overviewNote = json.overviewNote
    caregiver.personalityNote = json.personalityNote
    caregiver.skillNote = json.skillNote
    caregiver.notSuitableNote = json.notSuitableNote
    return caregiver
  }

  transformToDisplayable () {
    this.emergencyContact.relation = Readable.relation.from(this.emergencyContact.relation)
    this.maritalStatus = Readable.maritalStatus.from(this.maritalStatus)
    this.age = Convertable.date.from(this.birthDate).toAge() || ''
    this.birthDate = moment(this.birthDate).format('DD/MM/YYYY')
    this.gender = Readable.gender.from(this.gender)
    this.hasChildren = this.hasChildren ? 'มีบุตร' : 'ไม่มีบุตร'
    this.publicType = Readable.caregiver.type.publicFrom(this.type)
    this.type = Readable.caregiver.type.from(this.type)
    this.bankAccount.bank = Readable.bank.from(this.bankAccount.bank)
    this.careCertification = Readable.certification.from(this.careCertification)
    this.levelUpdatedAt = moment(this.levelUpdatedAt).format('DD/MM/YYYY')
    this.skillsDisplayable = this.skills
      .filter(s => s.improvable || s.score >= 7)
      .map(s => Readable.skill.from(s.name))
    this.generalSkills = this.skills
      .filter(s =>
        Value.skill.generalAll().includes(s.name)
      )
      .map(s => ({
        ...s,
        name: Readable.skill.from(s.name)
      }))
    this.otherSkills = this.skills
      .filter(s =>
        Value.skill.othersAll().includes(s.name)
      )
      .map(s => ({
        ...s,
        name: Readable.skill.from(s.name)
      }))
    return this
  }
}
